import camelCase from "lodash/camelCase";

const objectParser = (data, nData) => {
  Object.keys(data).forEach((key) => {
    nData[camelCase(key)] = camelizer(data[key]);
  });
  return nData;
};

const arrayParser = (data, nData) => {
  data.forEach((el, idx) => {
    nData[camelCase(idx)] = camelizer(el);
  });
  return nData;
};

export const camelizer = (data) => {
  if (Array.isArray(data)) {
    return arrayParser(data, []);
  } else if (data && typeof data == "object") {
    return objectParser(data, {});
  }
  return data;
};
